export default __webpack_public_path__ + "static/team_parallax-6073e4be8c17325fe5fb01ade51978c1.webm";